// Generated file : do not modify
export enum DialogAnswers
{
  NONE = 0,
  CANCEL,
  CONFIRM,
  DENY,
  PREVIOUS,
  REFRESH,
  EDIT_ITEM,
  DELETE_ITEM
};

export enum DialogTypes
{
  NONE = 0,
  OBJECT,
  TASK,
  DEBUG
};

import { ReasonSelect } from '@/extend/classes/Reason';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Dialogues
export class DialogParam {
  // Clé du paramètre
  public key: string;
  // Valeur résolue
  public value: string;

  constructor() {
    this.key = '';
    this.value = '';
  }
}

export class DialogCheck {
  // Libellé
  public label: string;
  // Requis
  public required: boolean;
  // Valeur
  public value: boolean;

  constructor() {
    this.label = '';
    this.required = false;
    this.value = false;
  }
}

export class DialogAnswerData {
  // Chaine saisie
  public value: string;
  // Checkbox saisies
  public checkValues: boolean[];
  // Choix selectionné et texte saisi
  public reason: ReasonSelect;

  constructor() {
    this.value = '';
    this.checkValues = [];
    this.reason = new ReasonSelect();
  }
}

export class DialogActionData {
  // Methode appelée ex: 'updateAdresse'
  public method: string;
  // Objet retourné : adresse
  public obj: unknown;

  constructor() {
    this.method = '';
    this.obj = null;
  }
}

export class WizardStep {
  // Identifiant de l'étape
  public enumStep: number;
  // Contexte de publication
  public publiContextId: number;
  // SysParam sérialisés
  public strSysParam: string;
  // Régles d'édition sous forme 'mask:111, focus:numeroSecu...'
  public rules: string;
  // Informations à valider
  public checks: DialogCheck[];
  // Choix à faire
  public reason: ReasonSelect;

  constructor() {
    this.enumStep = 0;
    this.publiContextId = 0;
    this.strSysParam = '';
    this.rules = '';
    this.checks = [];
    this.reason = new ReasonSelect();
  }
}

export class WizardRow {
  // Données en colonne
  public wizardCols: string[];

  constructor() {
    this.wizardCols = [];
  }
}

export default class Dialog  {
  // Identifiant unique
  public id: number;
  // Titre du dialogue
  public title: string;
  // Texte du dialogue
  public label: string;
  // Description
  public description: string;
  // Régles d'édition sous forme 'mask:111, focus:numeroSecu...'
  public rules: string;
  // Informations à valider ou choisir
  public checks: DialogCheck[];
  // Choix à faire
  public reason: ReasonSelect;
  // Données saisies
  public data: DialogAnswerData;
  // Liste des boutons affichés
  public buttons: string[];
  // réponse
  public answer: DialogAnswers;
  // réponse
  public type: DialogTypes;
  // Picto affiché dans le dialogue
  public picto: string;
  // Séquence du wizard
  public wizardSteps: WizardStep[];
  // données du wizard
  public wizardData: unknown;
  // Table du wizard
  public wizardRows: WizardRow[];
  // Laisse le dialogue affiché
  public keepOpenned: boolean;
  // Nom TitleCase du composant Vue associé (ex: PaymentSynthese)
  public dialogName: string;
  // Paramètres de publipostage résolus (clé/valeur)
  public publiParams: DialogParam[];
  // Texte du dialogue
  public labelHtmlId: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.title = '';
    this.label = '';
    this.description = '';
    this.rules = '';
    this.checks = [];
    this.reason = new ReasonSelect();
    this.data = new DialogAnswerData();
    this.buttons = [];
    this.answer = DialogAnswers.NONE;
    this.type = DialogTypes.NONE;
    this.picto = '';
    this.wizardSteps = [];
    this.wizardData = null;
    this.wizardRows = [];
    this.keepOpenned = false;
    this.dialogName = '';
    this.publiParams = [];
    this.labelHtmlId = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Dialog): Dialog {
    const newDialog: Dialog = new Dialog();
    newDialog.id = obj.id;
    newDialog.title = obj.title;
    newDialog.label = obj.label;
    newDialog.description = obj.description;
    newDialog.rules = obj.rules;
    newDialog.checks = JSON.parse(JSON.stringify(obj.checks));
    newDialog.reason = JSON.parse(JSON.stringify(obj.reason));
    newDialog.data = JSON.parse(JSON.stringify(obj.data));
    newDialog.buttons = JSON.parse(JSON.stringify(obj.buttons));
    newDialog.answer = obj.answer;
    newDialog.type = obj.type;
    newDialog.picto = obj.picto;
    newDialog.wizardSteps = JSON.parse(JSON.stringify(obj.wizardSteps));
    newDialog.wizardData = obj.wizardData;
    newDialog.wizardRows = JSON.parse(JSON.stringify(obj.wizardRows));
    newDialog.keepOpenned = obj.keepOpenned;
    newDialog.dialogName = obj.dialogName;
    newDialog.publiParams = JSON.parse(JSON.stringify(obj.publiParams));
    newDialog.labelHtmlId = obj.labelHtmlId;
    newDialog.canUpdate = obj.canUpdate;
    newDialog.canDelete = obj.canDelete;
    newDialog.display = obj.display;
    newDialog.notifDefType = obj.notifDefType;
    return newDialog;
  }

  public toJsonDialog (): string {
    const json = {
      title: this.title,
      label: this.label,
      description: this.description,
      rules: this.rules,
      checks: this.checks,
      reason: this.reason,
      data: this.data,
      buttons: this.buttons,
      answer: this.answer,
      type: this.type,
      picto: this.picto,
      wizardSteps: this.wizardSteps,
      wizardData: this.wizardData,
      wizardRows: this.wizardRows,
      keepOpenned: this.keepOpenned,
      dialogName: this.dialogName,
      publiParams: this.publiParams,
      labelHtmlId: this.labelHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromDialog (obj: Dialog): void {
    this.id = obj.id;
    this.title = obj.title;
    this.label = obj.label;
    this.description = obj.description;
    this.rules = obj.rules;
    this.checks = obj.checks;
    this.reason = obj.reason;
    this.data = obj.data;
    this.buttons = obj.buttons;
    this.answer = obj.answer;
    this.type = obj.type;
    this.picto = obj.picto;
    this.wizardSteps = obj.wizardSteps;
    this.wizardData = obj.wizardData;
    this.wizardRows = obj.wizardRows;
    this.keepOpenned = obj.keepOpenned;
    this.dialogName = obj.dialogName;
    this.publiParams = obj.publiParams;
    this.labelHtmlId = obj.labelHtmlId;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareDialog (value: Dialog): boolean {
    return (this.toJsonDialog() == value.toJsonDialog());
  }

  public cloneDialog (): Dialog {
    return Dialog.fromJson(this);
  }

  public update (): Promise<Dialog> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/dialogs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromDialog(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static answer (dialog: Dialog): Promise<Dialog> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/dialogs/answer', dialog, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Dialog.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Dialog> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Dialogs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Dialog.fromJson(listData.reccords[0] as Dialog);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(dialogs: Dialog[]) {
  }
}
